<template>
  <p class="unitTips flex-end">AQI(无量纲)，CO(mg/m³)，其他均为(μg/m³)</p>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
  destroyed() {},
};
</script>
<style lang='stylus' scoped>
.unitTips {
  font-size: 12px;
  font-weight: 400;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/unitTips.vue